export const cleanDigits = (str) => str.replace(/[^\d]+/g, ''); // remove all non-digit characters

export const sanitizeHTML = (str) => (str ? str.replace(/[&"'<>\\`:]/g, '') : str); // remove all dangerous tags

export const alphaNumericOnly = (str) => str.replace(/[^0-9a-zA-Z]/g, '');